
import React from 'react';

const MyWebsite = ({ onChange }) => {
  return (
    <div style={{ display: 'none' }}>
      <label htmlFor="myWebsite">Website</label>
      <input
        type="text"
        name="website"
        id="myWebsite"
        onChange={onChange}
        autoComplete="off"
        tabIndex="-1"
      />
    </div>
  );
};

export default MyWebsite;
